<div class="row">
  <div class="one-half">
    <label class="form-control">
      <span>{{label}}</span>
      <span class="border">
        <!-- | mask: 'separator' -->
        <img *ngIf="icon" [src]="'/assets/svgs/'+icon+'.svg'" alt="icon" class="icon">
        <input #minInput class="min" type="number" [value]="min" placeholder="de" (input)="updateSlider($event)"
          (blur)="updateInputOnBlur('min',minInput, maxInput)">
      </span>
    </label>
  </div>
  <div class="one-half">
    <label class="form-control">
      <span>&nbsp;</span>
      <span class="border">
        <!-- | mask: 'separator' -->
        <img *ngIf="icon" [src]="'/assets/svgs/'+icon+'.svg'" alt="icon" class="icon">
        <input #maxInput class="max" type="number" [(value)]="max" placeholder="até" (input)="updateSlider($event)"
          (blur)="updateInputOnBlur('max',minInput, maxInput)">
      </span>
    </label>
  </div>
</div>

<div class="slider">
  <span class="min" #minThumb (pointermove)="drag($event, maxThumb)"></span>
  <span class="max" #maxThumb (pointermove)="drag($event, minThumb)"></span>
</div>